
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: 'linear-gradient(135deg, #e8c4c4 0%, #d4a0a0 50%, #c9a0b0 100%)' }} className="text-gray-800">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/1f92c13e-7a54-4d8e-ad2a-ee26389fce64.png"
              alt="NIN Fashion"
              className="h-12 md:h-16 w-auto mb-4 md:mb-6"
            />
            <p className="text-gray-700 leading-relaxed mb-6 md:mb-8 text-sm">
              NIN Fashion es tu destino para moda femenina elegante y contemporánea. 
              Descubre colecciones únicas que reflejan tu estilo personal.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/nin.ofiicial/"
                className="w-10 h-10 rounded-full border border-gray-600/40 flex items-center justify-center hover:bg-white/30 transition-colors text-gray-700"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="https://www.tiktok.com/@nin.ofiicial"
                className="w-10 h-10 rounded-full border border-gray-600/40 flex items-center justify-center hover:bg-white/30 transition-colors text-gray-700"
                aria-label="TikTok"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <div className="mb-6">
              <h4 className="text-xs font-semibold tracking-wider mb-2 text-gray-600">
                TELÉFONO
              </h4>
              <p className="text-sm text-gray-700">+54 9 1125075865</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold tracking-wider mb-2 text-gray-600">
                EMAIL
              </h4>
              <p className="text-sm text-gray-700">ninfashion10@gmail.com</p>
            </div>
          </div>

          <div className="h-48 md:h-64 rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/ba1168cfb3a7bae1de0dc063dff3f09e.jpg"
              alt="NIN Fashion Store"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="border-t border-gray-600/20 mt-8 md:mt-12 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs md:text-sm text-gray-600 text-center md:text-left">© 2025 NIN Fashion. Todos los derechos reservados.</p>
          <div className="flex gap-4 md:gap-6">
            <Link to="#" className="text-xs md:text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap">
              Privacidad
            </Link>
            <Link to="#" className="text-xs md:text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap">
              Términos
            </Link>
            <Link to="#" className="text-xs md:text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}